import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import { screenXsMax, screenSmMin, spacer8, spacer12 } from '@spotify-internal/encore-foundation';
import { formControlInputIconTheme } from "../../styles";

var iconTheme = function iconTheme(props) {
  return props.theme.formInputIcon === 'dark' ? 'dark' : 'light';
}; // eslint-disable-next-line prefer-arrow-callback


export default styled(function Icon(_ref) {
  var InputIcon = _ref.icon,
      props = _objectWithoutProperties(_ref, ["icon"]);

  return React.createElement(InputIcon, props);
}).withConfig({
  displayName: "Icon",
  componentId: "sc-116d0if-0"
})(["position:absolute;pointer-events:none;", ";@media (max-width:", "){top:", ";left:0;}@media (min-width:", "){top:", ";left:", ";}"], function (props) {
  return formControlInputIconTheme(iconTheme(props));
}, screenXsMax, spacer8, screenSmMin, spacer12, spacer12);